import React from 'react';
import {
    Button,
    Checkbox,
    Col,
    Form,
} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import styled from "styled-components/macro";


const Wrapper = styled.div`
          border: 1px solid var(--global-main-color);
          border-radius: 5px;
          padding: 15px 25px;
          width: 100%;
          
          .consentInfo {
            white-space: pre-line;
          }
          
          .consentBlock + .consentBlock {
            margin-top: 18px;
            padding-top: 18px;
            border-top: 1px dashed rgba(158, 158, 158, 0.5);
          }
          
          .consentProducts {
            margin-bottom: 8px;
          }
          
          .consentDownload {
            margin-bottom: 12px;
          }
        `;

// Eigener Feldname, da initialValues.declarationConsents (Metadaten) ins Form gespreizt wird
export const DECLARATION_CONSENT_FIELD = 'declarationConsentAccepted';

const DeclarationConsent = ({consents}) => {

    const consentList = consents || [];

    if(!consentList.length) {
        return null;
    }

    return (
        <Col span={24}>
            <h2>{window.ENV.DECLARATION_CONSENT_HEADLINE || "Einverständniserklärung"}</h2>

            <Wrapper>
                {window.ENV.DECLARATION_CONSENT_INFO_TEXT ?
                    <p className={"consentInfo"}>{window.ENV.DECLARATION_CONSENT_INFO_TEXT}</p>
                : null}

                {consentList.map((consent, index) =>
                    <div className={"consentBlock"} key={consent.link}>
                        {consentList.length > 1 && consent.productNames.length ?
                            <p className={"consentProducts"}><b>{consent.productNames.join(', ')}</b></p>
                        : null}

                        <Button
                            className={"consentDownload"}
                            icon={<DownloadOutlined />}
                            href={consent.link}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                        >
                            {window.ENV.DECLARATION_CONSENT_LINK_TEXT || "Einverständniserklärung herunterladen"}
                        </Button>

                        <Form.Item
                            name={[DECLARATION_CONSENT_FIELD, index]}
                            valuePropName={"checked"}
                            required={true}
                            initialValue={false}
                            style={{marginBottom: 0}}
                            rules={[{required: true, transform: value => (value || undefined), type: 'boolean', message: window.ENV.DECLARATION_CONSENT_ERROR_TEXT || "Bitte bestätigen, dass die Einverständniserklärung heruntergeladen wurde."}]}
                        >
                            <Checkbox>{window.ENV.DECLARATION_CONSENT_CHECKBOX_TEXT || "Ich habe die Einverständniserklärung heruntergeladen und bringe sie ausgefüllt und unterschrieben mit."}</Checkbox>
                        </Form.Item>
                    </div>
                )}
            </Wrapper>
            <br/>
        </Col>
    );

}

export default DeclarationConsent;
